var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7599 7.87995C17.3274 7.87995 18.8306 8.50261 19.9389 9.61095C21.0473 10.7193 21.6699 12.2225 21.6699 13.7899V20.6849H17.7299V13.7899C17.7299 13.2675 17.5224 12.7664 17.1529 12.3969C16.7835 12.0275 16.2824 11.8199 15.7599 11.8199C15.2375 11.8199 14.7364 12.0275 14.3669 12.3969C13.9975 12.7664 13.7899 13.2675 13.7899 13.7899V20.6849H9.84995V13.7899C9.84995 12.2225 10.4726 10.7193 11.5809 9.61095C12.6893 8.50261 14.1925 7.87995 15.7599 7.87995Z",
    stroke: "white",
    strokeWidth: 1.96999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90996 8.86495H1.96997V20.6849H5.90996V8.86495Z",
    stroke: "white",
    strokeWidth: 1.96999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93997 5.90996C5.02796 5.90996 5.90996 5.02796 5.90996 3.93997C5.90996 2.85197 5.02796 1.96997 3.93997 1.96997C2.85197 1.96997 1.96997 2.85197 1.96997 3.93997C1.96997 5.02796 2.85197 5.90996 3.93997 5.90996Z",
    stroke: "white",
    strokeWidth: 1.96999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialLinkedin);
export default __webpack_public_path__ + "static/media/social-linkedin.894433620b05721f37da690b5ec89844.svg";
export { ForwardRef as ReactComponent };